import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import { Grid, Box, Typography, Fade } from "@mui/material";
import uploadAnimationData from "../../components/animations/resume-parsing.json";
import { motion } from "framer-motion";

const Loading = () => {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [delayMessage, setDelayMessage] = useState(false);

  const messages = [
    "Uploading Resume...",
    "Parsing Resume...",
    "Calculating total relevant experience (in months)...",
    "Extracting all your skills...",
    "Looking for soft skills...",
    "Looking for roles...",
    "Looking for Certifications...",
    "Locating education history...",
    "Finding Job History...",
    "Identifying all other attributes...",
    "Searching for Hobbies and Interests...",
    "Identifying Seniority...",
    "Identifying missing elements...",
    "Adding missing elements to ensure you get the BEST salary...",
    "Initiating TrueSelfy algorithm calculation...",
    "Computing your salary based on identified elements...",
    "Calculating your TrueValue you bring to the organization...",
  ];

  useEffect(() => {
    // Cycle through short messages every 4 seconds (0-20 seconds)
    const messageInterval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 3000); // Change message every 4 seconds

    // Trigger the delay message after 20 seconds
    const delayTimer = setTimeout(() => {
      setDelayMessage(true);
      clearInterval(messageInterval); // Stop cycling messages
    }, 51000); // 20 seconds

    return () => {
      clearInterval(messageInterval);
      clearTimeout(delayTimer);
    };
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: uploadAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Lottie options={defaultOptions} height={230} width={230} />
        <Fade in timeout={800} key={currentMessage}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#FDF9E0" }}>
            {delayMessage
              ? "Almost there! We're finalizing your results..."
              : messages[currentMessage]}
          </Typography>
        </Fade>
      </Box>
    </Grid>
  );
};

export default Loading;
